import axios from "axios";

const dropboxApi = axios.create({
  baseURL: import.meta.env.VITE_MAPBOX_API,
  headers: {
    "Content-Type": "application/json",
  },
});

export default dropboxApi;
